import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

const DESCRIPTION_PREVIEW_MAX_WIDTH = "320px";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minHeight: 0,
    minWidth: 0,
  },
  sampleQuestionsGrid: {
    display: "grid",
    gap: designTokens.spacing[3],
    maxHeight: "280px",
    overflowY: "auto",
    paddingTop: designTokens.spacing[3],
    paddingBottom: designTokens.spacing[3],
    borderTop: `1px solid ${designTokens.neutral[200]}`,
    borderBottom: `1px solid ${designTokens.neutral[200]}`,
  },
  sampleQuestionItem: {
    display: "flex",
    alignItems: "center",
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    border: `1px solid ${designTokens.neutral[200]}`,
    borderRadius: designTokens.borderRadius.md,
    width: "100%",
    boxSizing: "border-box",
  },
  cellContent: {
    paddingTop: designTokens.spacing[3],
    paddingBottom: designTokens.spacing[3],
    lineHeight: "2",
    width: "100%",
    overflow: "visible",
  },
  descriptionPreview: {
    display: "block",
    // Fluent renders a native <table> with `table-layout: auto`, so the cell
    // grows to fit its content. An explicit max-width is what gives the span a
    // definite box for `text-overflow` to clip against.
    maxWidth: DESCRIPTION_PREVIEW_MAX_WIDTH,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  wrapper: {
    display: "flex",
    flexDirection: "column",
    paddingTop: designTokens.spacing[4],
    gap: designTokens.spacing[4],
    width: "100%",
    overflowY: "auto",
  },
  hintText: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
    fontFamily: designTokens.fontFamily,
    fontStyle: "italic",
    paddingLeft: designTokens.spacing[6],
    marginTop: `-${designTokens.spacing[3]}`,
  },
});
